export const GET_AUTOMATED_MESSAGES_LIST = 'GET_AUTOMATED_MESSAGES_LIST';
export const GET_AUTOMATED_MESSAGES_LIST_REQUEST =
  'GET_AUTOMATED_MESSAGES_LIST_REQUEST';

export const SAVE_MESSAGE_REQUEST = 'SAVE_MESSAGE_REQUEST';
export const SAVE_MESSAGE_SUCCESS = 'SAVE_MESSAGE_SUCCESS';
export const SAVE_MESSAGE_FAILURE = 'SAVE_MESSAGE_FAILURE';
